/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Loading/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import LoadingSpinner from 'DesignSystem/LoadingSpinner/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Loading({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/ScheduleOptions/Content/LocationSelect/Content/Loading"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let constantData = 'Loading calendar for '
let tabSelectedLocationNameValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.location_name',
})
let aggregateData = fromAggregate.join(constantData, tabSelectedLocationNameValueData)
  return (<React.Fragment
>
<div
  data-testid="Loading.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-2mx3jB': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<LoadingSpinner
  viewPath={`${viewPath}/LoadingSpinner`}
 height={dtSpaceS}
 width={dtSpaceS}
 delay={0}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="'Loading calendar for '"
 data="tab.selected.location_name"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
/>
</div>
{children}
</React.Fragment>)
}